export const analyticsNumber = (value: unknown) => new Intl.NumberFormat('pt-BR', {maximumFractionDigits: 0}).format(Number(value || 0))
export const analyticsPercent = (value: number) => `${value.toLocaleString('pt-BR', {maximumFractionDigits: 1})}%`
export const analyticsDuration = (value: unknown) => {
  const ms = Number(value || 0)
  if (ms >= 60000) return `${(ms / 60000).toLocaleString('pt-BR', {maximumFractionDigits: 1})} min`
  if (ms >= 1000) return `${(ms / 1000).toLocaleString('pt-BR', {maximumFractionDigits: 1})} s`
  return `${Math.round(ms).toLocaleString('pt-BR')} ms`
}
// Calendar buckets represent UTC dates, not timestamps in the viewer's timezone.
export const analyticsBucketLabel = (value: string, hourly = false) => {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return new Intl.DateTimeFormat('pt-BR', hourly
    ? {hour: '2-digit', minute: '2-digit', timeZone: 'UTC'}
    : {day: '2-digit', month: 'short', timeZone: 'UTC'}).format(date)
}
export const analyticsShare = (value: unknown, total: unknown) => Number(total) > 0
  ? Math.min(100, Math.max(0, Number(value || 0) / Number(total) * 100))
  : 0
